import Blockly, { Block } from 'blockly';

import * as It from 'blockly/msg/it';
import * as Lt from 'blockly/msg/lt';
import * as Fr from 'blockly/msg/fr';
import * as En from 'blockly/msg/en';
import * as De from 'blockly/msg/de';
import { getLocale } from './Locale.js';

var contextMenuRegistered = false;
var themeCounterHack = 0;
export class Playground {
    constructor(selector = '#workspace', codeGenerationFunction, toolbox = {}, blocks = [], theme = null, workspaceCallback = null) {
        const blocklyDiv = document.querySelector(selector);

        const lang = getLocale();
        console.log(lang)
        if (lang === 'fr') {
            Blockly.setLocale(Fr);
        } else if (lang == 'en') {
            Blockly.setLocale(En);
        } else if (lang == 'lt') {
            Blockly.setLocale(Lt);
        } else if (lang == 'it') {
            Blockly.setLocale(It);
        } else if (lang == 'de') {
            Blockly.setLocale(De);
        }

        Blockly.defineBlocksWithJsonArray(blocks);
        themeCounterHack++;
        if (theme) {
            this.theme = Blockly.Theme.defineTheme('DialogTheme' + themeCounterHack, {
                'blockStyles': theme.defaultBlockStyles,
                'categoryStyles': theme.defaultCategoryStyles,
                // 'componentStyles': componentStyles,
                // 'fontStyle': fontStyle,
                'startHats': true
            });
        }

        var downloadWorkspace = function (event) {

            var xmltext = this.getWorkspace();
            var filename = "myFakeProject.xml";
            var pom = document.createElement('a');
            var bb = new Blob([xmltext], {
                type: 'text/plain'
            });

            pom.setAttribute('href', window.URL.createObjectURL(bb));
            pom.setAttribute('download', filename);

            pom.dataset.downloadurl = ['text/plain', pom.download, pom.href].join(':');
            pom.draggable = true;
            pom.classList.add('dragout');

            pom.click();
        }.bind(this)


        function registerDownloadContextMenuOptions() {
            const workspaceItem = {
                displayText: '💾 Download to file',
                preconditionFn: function (scope) {
                    return 'enabled';
                },
                callback: downloadWorkspace,
                scopeType: Blockly.ContextMenuRegistry.ScopeType.WORKSPACE,
                id: 'download_workspace',
                weight: -2,
            };
            Blockly.ContextMenuRegistry.registry.register(workspaceItem);
            contextMenuRegistered = true;
        }

        function readFile(evt) {
            var files = evt.target.files;
            var file = files[0];
            var reader = new FileReader();
            reader.onload = function (event) {
                //Blockly.getMainWorkspace().clear();
                Blockly.Xml.appendDomToWorkspace(Blockly.Xml.textToDom(event.target.result), Blockly.getMainWorkspace())
            }
            reader.readAsText(file);
        }

        function registerUploadContextMenuOptions() {
            const workspaceItem = {
                displayText: '🔼 Import from file',
                preconditionFn: function (scope) {
                    return 'enabled';
                },
                callback: function (e) {
                    var fileInput = document.createElement('input');
                    fileInput.type = 'file';
                    fileInput.accept = '.xml';
                    fileInput.addEventListener('change', function (evt) {
                        readFile(evt);
                    });
                    fileInput.click();
                },
                scopeType: Blockly.ContextMenuRegistry.ScopeType.WORKSPACE,
                id: 'upload_workspace',
                weight: -1,
            };
            Blockly.ContextMenuRegistry.registry.register(workspaceItem);
        }
        if (!contextMenuRegistered) {
            registerDownloadContextMenuOptions();
            registerUploadContextMenuOptions();
        }

        this.workspace = Blockly.inject(blocklyDiv,
            {
                toolbox: toolbox,
                theme: this.theme,
                renderer: 'geras',
                media: './media/',
                zoom:
                {
                    controls: true,
                    wheel: true,
                    startScale: 0.9,
                    maxScale: 1.1,
                    minScale: 0.5,
                    scaleSpeed: 1.2,
                    pinch: true
                },
                grid:
                {
                    spacing: 20,
                    length: 3,
                    colour: '#ccc',
                    snap: true
                },
                trashcan: true,
                move: {
                    scrollbars: {
                        horizontal: true,
                        vertical: true
                    },
                    drag: true,
                    wheel: false
                }
            });
        var onresize = function (e) {

            Blockly.svgResize(this.workspace);
        }.bind(this);
        window.addEventListener('resize', onresize, false);

        onresize();

        this.codeGeneration = codeGenerationFunction;
        this.codeGeneration();

        function workspaceEvent(event) {
            // if (event.type == Blockly.Events.BLOCK_CHANGE &&
            //     event.element == 'comment' &&
            //     !event.oldValue && event.newValue) {
            //   alert('Congratulations on creating your first comment!')
            //   workspace.removeChangeListener(onFirstComment);
            // }
            //console.log(event);
            if (event instanceof Blockly.Events.Ui) {
                return;  // Don't mirror UI events.
            }
            if (workspaceCallback) {
                workspaceCallback(event)
            }
        };
        this.workspace.addChangeListener(workspaceEvent.bind(this));
    }

    getCode() {
        const code = Blockly.JavaScript.workspaceToCode(Blockly.getMainWorkspace())
        return code;
    }

    getBlocks() {
        return Blockly.getMainWorkspace().getAllBlocks(true);
    }

    clearWorkspace() {
        this.setWorkspace();
    }

    setWorkspace(xmlString) {
        if (!xmlString)
            xmlString = "<xml></xml>";

        Blockly.Xml.clearWorkspaceAndLoadFromXml(Blockly.Xml.textToDom(xmlString), Blockly.getMainWorkspace());

    }

    getWorkspace() {
        var xml = Blockly.Xml.workspaceToDom(Blockly.getMainWorkspace());
        const serializer = new XMLSerializer();
        const xmlStr = serializer.serializeToString(xml);
        return xmlStr;
    }


}